import type {SearchRules} from '../../types';
import {SearchTypeVisual} from '../';

/**
 * Check if rules contain specified visual type
 * @param searchRules Search rules
 * @returns Contains visual
 */
export const rulesContainVisual = (searchRules: Partial<SearchRules>) =>
	!!searchRules.elementTypes &&
	searchRules.elementTypes.some(
		(elementType) => elementType === SearchTypeVisual,
	);

export default rulesContainVisual;
